import { Session } from '@/models/session'

const abbreviatte = (str?: string, count = 1): string =>
  `${str?.substring(0, count)}.`

const formatName = (user?: Session): string => {
  return `${user?.preferred_name || user?.first_name}${
    user?.last_name ? ' ' + abbreviatte(user?.last_name) : ''
  }`
}

export default formatName
